import React from "react";
import ReactDOM from "react-dom/client";
import PDMDemonstrator from "./PDMDemonstrator";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PDMDemonstrator />
  </React.StrictMode>
);
